import { useState, useEffect } from 'react';
import { Box, Paper, Stepper, Step, StepLabel, Button, Typography, Snackbar, Alert, FormControlLabel, Switch, IconButton, Divider } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import ClientDetails from './components/ClientDetails';
import ProductDetails from './components/ProductDetails';
import ConsignerDetails from './components/ConsignerDetails';
import TransporterDetails from './components/TransporterDetails';
import ExportDetails from './components/ExportDetails';
import InquiryReview from './components/InquiryReview';
import { useAuth } from '../../context/AuthContext';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import axios from 'axios';

/*
 * Robust deep merge utility (immutable).
 *
 * Supported options:
 *   - arrayMerge: "replace" | "concat" | "mergeByIndex"  (default: "replace")
 *   - preservePrototype: boolean (default: false) - usually false is safer
 *
 * Behavior highlights:
 *  - Plain objects are merged recursively.
 *  - Arrays handled by chosen strategy.
 *  - Dates & RegExps are cloned.
 *  - Functions / other non-plain objects are copied by reference.
 *  - Circular refs are preserved (WeakMap).
 */
// function isPlainObject(value) {
//     return Object.prototype.toString.call(value) === '[object Object]';
// }

// function cloneValue(value, refs = new WeakMap()) {
//     if (value === null || value === undefined) return value;
//     if (value instanceof Date) return new Date(value.getTime());
//     if (value instanceof RegExp) return new RegExp(value.source, value.flags);
//     if (Array.isArray(value)) return value.map(v => cloneValue(v, refs));
//     if (isPlainObject(value)) return mergeDeep({}, value, { arrayMerge: 'replace' }, refs);
//     // For functions and other objects (Map, Set, Buffer, custom class) return as-is (reference)
//     return value;
// }

// function mergeDeep(target = {}, source = {}, options = {}, refs = null) {
//     const { arrayMerge = 'replace', preservePrototype = false } = options;
//     // Use WeakMap to track visited nodes and avoid infinite recursion on circular refs
//     if (!refs) refs = new WeakMap();

//     // Primitive shortcut
//     if (!isPlainObject(source) && !Array.isArray(source)) {
//         // if source is Date/RegExp we want cloned instance
//         return cloneValue(source, refs);
//     }

//     // If circular reference already present, return recorded ref
//     if (refs.has(source)) return refs.get(source);

//     // Prepare result copy (do not mutate inputs)
//     let output;
//     if (Array.isArray(source)) {
//         // If target isn't an array, start fresh (do not try to treat objects like arrays)
//         const left = Array.isArray(target) ? target.slice() : [];
//         if (arrayMerge === 'replace') {
//             output = source.map(v => cloneValue(v, refs));
//         } else if (arrayMerge === 'concat') {
//             output = left.map(v => cloneValue(v, refs)).concat(source.map(v => cloneValue(v, refs)));
//         } else if (arrayMerge === 'mergeByIndex') {
//             const max = Math.max(left.length, source.length);
//             output = new Array(max);
//             refs.set(source, output);
//             for (let i = 0; i < max; i++) {
//                 if (i in source && i in left) {
//                     output[i] = mergeDeep(left[i], source[i], options, refs);
//                 } else if (i in source) {
//                     output[i] = cloneValue(source[i], refs);
//                 } else {
//                     output[i] = cloneValue(left[i], refs);
//                 }
//             }
//             return output;
//         } else {
//             // unknown strategy -> replace
//             output = source.map(v => cloneValue(v, refs));
//         }
//         refs.set(source, output);
//         return output;
//     }

//     // source is plain object
//     output = preservePrototype ? Object.create(Object.getPrototypeOf(target || {})) : {};
//     refs.set(source, output);

//     // copy keys from target first (so source overwrites)
//     if (isPlainObject(target)) {
//         for (const k of Object.keys(target)) {
//             output[k] = cloneValue(target[k], refs);
//         }
//     }

//     // merge keys from source
//     for (const key of Object.keys(source)) {
//         const sVal = source[key];
//         const tVal = (isPlainObject(target) && key in target) ? target[key] : undefined;

//         if (isPlainObject(sVal)) {
//             output[key] = mergeDeep(isPlainObject(tVal) ? tVal : {}, sVal, options, refs);
//             continue;
//         }

//         if (Array.isArray(sVal)) {
//             // Choose strategy relative to target
//             if (arrayMerge === 'mergeByIndex' && Array.isArray(tVal)) {
//                 // merge arrays item wise
//                 const max = Math.max(tVal.length, sVal.length);
//                 const arr = new Array(max);
//                 refs.set(sVal, arr);
//                 for (let i = 0; i < max; i++) {
//                     if (i in sVal && i in tVal) arr[i] = mergeDeep(tVal[i], sVal[i], options, refs);
//                     else if (i in sVal) arr[i] = cloneValue(sVal[i], refs);
//                     else arr[i] = cloneValue(tVal[i], refs);
//                 }
//                 output[key] = arr;
//             } else if (arrayMerge === 'concat' && Array.isArray(tVal)) {
//                 output[key] = (tVal || []).map(v => cloneValue(v, refs)).concat(sVal.map(v => cloneValue(v, refs)));
//             } else {
//                 // replace
//                 output[key] = sVal.map(v => cloneValue(v, refs));
//             }
//             continue;
//         }

//         // handle Date/RegExp/cloned primitives
//         output[key] = cloneValue(sVal, refs);
//     }

//     return output;
// }

// // In your component file (replace previous deepMerge)
// function mergeFormData(prev, stepData) {
//     // stepData is expected to be a "partial" object like { client: {...} } or { product: {...} }
//     // We intentionally replace arrays (most multi-step forms replace entire arrays from a single step).
//     return mergeDeep(prev || {}, stepData || {}, { arrayMerge: 'replace', preservePrototype: false });
// }

// // Usage in handleNext
// const handleNext = (stepData = {}) => {
//     console.log('Step data:', stepData);
//     setFormData(prev => mergeFormData(prev, stepData));
//     setActiveStep(prev => prev + 1);
// };

// Utility function for deep merging objects (simple, kept uncommented for usage)
const deepMerge = (target, source) => {
    const output = { ...target };
    for (const key in source) {
        if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
            output[key] = deepMerge(target[key] || {}, source[key]);
        } else {
            output[key] = source[key];
        }
    }
    return output;
};


const steps = ['Client Details', 'Product Details', 'Dispatch Details', 'Review & Submit'];

const PurcInvoiceMaster = ({ mode, connectionString, onPopupCancel }) => {
    let path = connectionString;
    // Read route parameters (be flexible — some routes use :SOAutoID)
    const params = useParams();
    // routeSaleInvoiceId will pick common parameter names if provided
    const { user, selectedCompany, loading } = useAuth();
    const routeSaleInvoiceId = params.SOAutoID || params.saleInvoiceId || params.purcInvoiceId || params.id || null;
    const userId = user?.UserId || null;
    const companyId = selectedCompany?.CompId || null;
    const AppRegID = selectedCompany?.AppRegID || null;
    const userCategory = user?.UserCategory || null;

    // location.state when navigating programmatically (you pass { clientId, invoiceId } there)
    const location = useLocation();
    const { state } = location || {};

    // These are the values you asked to print/verify: try both route param and navigation state
    const incomingClientId = params.clientId ?? state?.clientId ?? null;
    const incomingInvoiceIdFromState = state?.invoiceId ?? null;

    // final invoice id to use (prefer route param if present, otherwise the state)
    const routeOrStateInvoiceId = routeSaleInvoiceId || incomingInvoiceIdFromState;

    const navigate = useNavigate();
    const [activeStep, setActiveStep] = useState(0);
    const [formData, setFormData] = useState({});
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
    const [consignerEnabled, setConsignerEnabled] = useState(true);
    const [transporterEnabled, setTransporterEnabled] = useState(true);
    const [exportEnabled, setExportEnabled] = useState(false);
    const [DebitNoteCreated, setDebitNoteCreated] = useState(false);

    // If user came from selection (Go To Purchase Invoice), this will be populated
    const challanIds = state?.selectedChallanAutoIDs || [];

    // Print values to console (for debug)
    useEffect(() => {
        console.log('PurcInvoiceMaster mounted.');
        console.log('Route param(s):', params.clientId);
        console.log('Location.state:', state);
        console.log('Incoming clientId (from state):', incomingClientId);
        console.log('Incoming invoiceId (from state):', incomingInvoiceIdFromState);
        console.log('Route or state invoice id chosen:', routeOrStateInvoiceId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // ── on mount, fetch existing challan and seed formData ────────────────────────
    useEffect(() => {
        if (mode !== 'ref' || !challanIds || challanIds.length === 0) {
            if (mode === 'ref' && !(state?.selectedPOIds && state.selectedPOIds.length > 0)) {
                setSnackbar({ open: true, message: 'No challans selected.', severity: 'error' });
            }
            return;
        }

        const fetchChallan = async () => {
            try {
                // If location state included clientId, include it, otherwise server can infer from challan ids
                const payload = incomingClientId ? { clientId: incomingClientId, challanIds } : { challanIds };
                console.log('Fetching challan(s) with payload:', payload);
                const res = await axios.post(`${path}/api/Purc-challans`, payload);
                let data = res.data;
                if (Array.isArray(data)) data = data[0] ?? {};
                if (!data || Object.keys(data).length === 0) {
                    throw new Error('Empty challan response');
                }
                console.log('Fetched challan (ref):', data);
                setFormData(data);
                // setConsignerEnabled(Boolean(data.consigner));
                setTransporterEnabled(Boolean(data.transporter) || Boolean(data.consigner));
                setExportEnabled(Boolean(data.export));
                // setSnackbar({ open: true, message: 'Challan data fetched successfully!', severity: 'success' });
            } catch (err) {
                console.error('Failed to load challan', err);
                if (err.response && err.response.status === 404) {
                    setSnackbar({ open: true, message: 'Challan not found for the given ID and client.', severity: 'error' });
                } else {
                    setSnackbar({ open: true, message: 'Failed to load Challan', severity: 'error' });
                }
            }
        };

        fetchChallan();
    }, [mode, challanIds, incomingClientId]);

    // Reference = Purchase Order: fetch the selected purchase orders and seed formData
    useEffect(() => {
        if (mode !== 'ref' || !state?.selectedPOIds || state.selectedPOIds.length === 0) return;

        const fetchPurchaseOrders = async () => {
            try {
                const res = await axios.post(`${path}/api/Purc-order-refs`, { clientId: incomingClientId, poIds: state.selectedPOIds });
                let data = res.data;
                if (Array.isArray(data)) data = data[0] ?? {};
                if (!data || Object.keys(data).length === 0) {
                    throw new Error('Empty purchase order response');
                }
                setFormData(data);
                setTransporterEnabled(Boolean(data.transporter) || Boolean(data.consigner));
                setExportEnabled(Boolean(data.export));
            } catch (err) {
                console.error('Failed to load purchase order', err);
                setSnackbar({ open: true, message: 'Failed to load Purchase Order', severity: 'error' });
            }
        };

        fetchPurchaseOrders();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mode]);

    // If mode === 'edit', fetch invoice info (use route param or state invoice id)
    useEffect(() => {
        const invoiceIdToUse = routeOrStateInvoiceId;
        if (mode === 'edit') {
            if (!invoiceIdToUse) {
                console.warn('Edit mode but no invoice id found (route param or state).');
                setSnackbar({ open: true, message: 'No invoice id provided for edit mode.', severity: 'error' });
                return;
            }

            axios.get(`${path}/api/PurcInvoice-getinfo`, { params: { saleInvoiceId: invoiceIdToUse } })
                .then(res => {
                    console.log("Invoice Data:", res.data);
                    setFormData(res.data);
                    setConsignerEnabled(res.data.consigner !== null);
                    setTransporterEnabled(res.data.transporter !== null || res.data.consigner !== null);
                    setExportEnabled(res.data.export !== null);

                    // also log the incoming ids again in case this fetch is what we consider canonical
                    console.log('Edit fetch completed. invoiceId used:', invoiceIdToUse, 'clientId from state:', incomingClientId);
                })
                .catch(err => {
                    console.error("Error fetching invoice:", err);
                    setSnackbar({ open: true, message: 'Failed to load invoice for editing.', severity: 'error' });
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [routeOrStateInvoiceId, mode]);

    useEffect(() => {
        if (mode !== 'edit' || !routeOrStateInvoiceId) return;

        const checkSaleInvoiceLock = async () => {
            try {
                const res = await axios.get(
                    `${path}/api/check-DebitNote-from-Invoice/${routeOrStateInvoiceId}`
                );

                if (res.data?.DebitNoteCreated) {
                    setDebitNoteCreated(true);
                    // setSnackbar({
                    //     open: true,
                    //     severity: 'warning',
                    //     message: 'Sale Invoice already exists. Products cannot be edited.'
                    // });
                }
            } catch (err) {
                console.error('Purchase invoice lock check failed', err);
            }
        };

        checkSaleInvoiceLock();
    }, [mode, routeOrStateInvoiceId]);

    const handleNext = (stepData = {}) => {
        console.log('Step data:', stepData);
        setFormData(prev => deepMerge(prev, stepData));
        setActiveStep(prev => prev + 1);
    };

    const handleBack = () => setActiveStep(prev => prev - 1);

    const handleSubmit = async () => {

        try {
            const payload = {
                client: formData.client,
                product: formData.product,
                consigner: transporterEnabled ? formData.consigner : null,
                transporter: transporterEnabled ? formData.transporter : null,
                export: exportEnabled ? formData.export : null,
                clientId: incomingClientId ?? formData.client?.clientId ?? null,
                companyId,
                userId,
                AppRegID
            };

            console.log('Submitting payload:', payload);

            if (mode === 'add' || mode === 'ref') {
                await axios.post(`${path}/api/create-PurchaseInvoice`, payload);
            }
            if (mode === 'edit') {
                const invoiceIdToUse = routeOrStateInvoiceId;
                await axios.put(`${path}/api/PurcInvoice-update/${invoiceIdToUse}`, payload);
            }

            setSnackbar({
                open: true,
                message: mode === 'add' ? 'Invoice created successfully!' : 'Invoice updated successfully!',
                severity: 'success',
            });

            // keep current UI; you can navigate away if desired:

            setActiveStep(0);
            setFormData({});
            setTimeout(() => {
                if (typeof onPopupCancel === "function") onPopupCancel();
                else navigate(-1);
            }, 600)
        } catch (error) {
            console.error(error);
            setSnackbar({ open: true, message: 'Failed to submit invoice.', severity: 'error' });
        }
    };

    const handleCancel = () => {
        if (typeof onPopupCancel === "function") {
            onPopupCancel();
        } else {
            navigate(-1);
        }
    };

    // Sync activeStep with URL changes (e.g., browser back button).
    // Note: by the time popstate fires, the browser has ALREADY moved history
    // back one entry — calling handleCancel()/navigate(-1) here would pop a
    // SECOND entry on top of that, overshooting past the intended page. Just
    // reset local wizard state; the browser's own navigation handles the page.
    useEffect(() => {
        const handlePopState = () => {
            setActiveStep(0);
        };
        window.addEventListener('popstate', handlePopState);
        return () => window.removeEventListener('popstate', handlePopState);
    }, []);

    // ──────────────── Alt+C (Cancel) shortcut — works from any step ───────────
    // Attached here (the wizard's parent), not per-step, so it works regardless
    // of which step (Client Details / Product Details / Dispatch Details /
    // Review) is active — those step components don't each carry their own
    // cancel concept.
    // Attached to document in the capture phase so it fires regardless of which
    // field/dropdown currently has focus, including MUI popper/portal content.
    // Uses e.code (physical key position) instead of e.key so this also works on
    // macOS, where Option+letter often produces an accented/dead-key character
    // via e.key (e.g. Option+C → "ç") instead of the plain letter.
    useEffect(() => {
        const handleGlobalKeyDown = (e) => {
            if (!e.altKey || e.code !== "KeyC") return;
            e.preventDefault();
            handleCancel();
        };

        document.addEventListener("keydown", handleGlobalKeyDown, true);
        return () => document.removeEventListener("keydown", handleGlobalKeyDown, true);
    }, [handleCancel]);

    const hasChallanLinked =
        Array.isArray(formData?.product?.tableData) &&
        formData.product.tableData.some(
            r => r?.challanDtsID != null || r?.challanID != null || r?.POID != null || r?.PODtsID != null
        );

    const handleCloseSnackbar = () => setSnackbar(prev => ({ ...prev, open: false }));

    const renderStepHeader = (icon, title, control = null) => (
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <Box display="flex" alignItems="center">
                {activeStep > 0 && (
                    <IconButton onClick={handleBack} size="small" sx={{ mr: 1 }}>
                        <ArrowBack />
                    </IconButton>
                )}
                <Typography variant="h6" fontWeight="bold">{icon} {title}</Typography>
            </Box>
            {control}
        </Box>
    );

    const getStepComponent = (step) => {
        switch (step) {
            case 0: return (
                <>
                    {renderStepHeader('1️⃣', 'Client Details')}
                    <ClientDetails mode={mode} connectionString={connectionString} initialData={formData.client || {}} onNext={(data) => handleNext({ client: data })} disablePartyName={hasChallanLinked} DebitNoteCreated={DebitNoteCreated} />
                </>);

            case 1:
                return (
                    <>
                        {renderStepHeader('2️⃣', 'Product Details')}
                        <ProductDetails initialData={formData.product || {}} connectionString={connectionString} L_No={formData.L_No || null} onNext={(data) => handleNext({ product: data })} clientData={formData.client || {}} challanIds={challanIds} mode={mode} DebitNoteCreated={DebitNoteCreated}
                            onRowsChange={(rows) => {
                                setFormData(prev => ({
                                    ...prev,
                                    product: {
                                        ...(prev.product || {}),
                                        tableData: rows,
                                    }
                                }));
                            }} />
                    </>
                );
            /* COMBINED STEP (Step 2 consignee and despatch details) */
            case 2:
                return (
                    <>
                        {renderStepHeader('3️⃣', 'Dispatch Details', (<FormControlLabel control={<Switch checked={transporterEnabled} onChange={e => setTransporterEnabled(e.target.checked)} />} label="Enable" />))}
                        {transporterEnabled ? (
                            <>
                                <Box sx={{ display: 'flex', flexDirection: "column", gap: 4 }}>
                                    <ConsignerDetails
                                        clientData={formData.client || {}}
                                        initialData={formData.consigner}
                                        connectionString={connectionString}
                                        onChange={(data) =>
                                            setFormData(prev => ({ ...prev, consigner: data }))
                                        } />

                                    <TransporterDetails
                                        initialData={formData.transporter || {}}
                                        connectionString={connectionString}
                                        onChange={(data) =>
                                            setFormData(prev => ({
                                                ...prev,
                                                transporter: data
                                            }))

                                        }

                                    />
                                </Box>


                                {/* ✅ SINGLE NEXT BUTTON */}
                                <Box mt={3} display="flex" justifyContent="flex-end">
                                    <Button
                                        variant="contained"
                                        // disabled={
                                        //     !formData?.consigner?.shipFrom ||
                                        //     !formData?.consigner?.shipTo ||
                                        //     !formData?.transporter?.transporterName
                                        // }
                                        onClick={() => {
                                            handleNext({
                                                consigner: formData.consigner,
                                                transporter: formData.transporter
                                            });
                                        }}
                                    >
                                        Next
                                    </Button>
                                </Box>

                            </>
                        ) : (
                            <Box mt={2}>
                                <Typography color="text.secondary">Dispatch details are skipped.</Typography>
                                <Button variant="contained" onClick={() => handleNext({})}>Continue</Button>
                            </Box>
                        )}

                    </>
                );
            case 3: return (<InquiryReview formData={formData} selectedCompany={selectedCompany} onBack={handleBack} onSubmit={handleSubmit} onEditStep={(stepIndex) => setActiveStep(stepIndex)} mode={mode} DebitNoteCreated={DebitNoteCreated} connectionString={connectionString} />);

            default: return null;
        }
    };

    return (
        <Box maxWidth="lg" mx="auto" px={2} py={2} pb={0}>
            {/* <Typography variant="h5" sx={{ textAlign: 'center', fontSize: { xs: '1.25rem', sm: '1.5rem' }, fontWeight: 600, mt: -0.5, mb: 1 }}>
                {mode === 'edit' ? 'Edit Purchase Invoice' : 'Add New Purchase Invoice'}
            </Typography> */}

            <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 0.6, mt: -1.5 }}>
                {/* Back arrow — mobile/tablet only */}
                <IconButton onClick={() => navigate(-1)} sx={{ position: 'absolute', left: 0, display: { xs: 'flex', md: 'none' }, color: 'text.secondary', p: 0.5, }} >
                    <ArrowBackIcon fontSize="small" />
                </IconButton>

                <Typography variant="h5" sx={{ textAlign: 'center', fontSize: { xs: '1.25rem', sm: '1.5rem' }, fontWeight: 600 }}>
                    {mode === 'edit' ? 'Edit Purchase Invoice' : 'Add New Purchase Invoice'}
                </Typography>
            </Box>

            {/* --- Display the received IDs (from route param and/from location.state) --- */}
            {/* <Paper elevation={1} sx={{ mb: 2, p: 2, borderRadius: 2 }}>
                <Typography variant="subtitle1">Received values (debug):</Typography>
                <Typography variant="body2">Route param (possible names): {JSON.stringify(params)}</Typography>
                <Typography variant="body2">Location.state (navigation): {JSON.stringify(state)}</Typography>
                <Typography variant="body2" sx={{ mt: 1, fontWeight: 600 }}>
                    clientId (from state): {incomingClientId ?? 'N/A'} &nbsp; | &nbsp;
                    purcInvoiceId (route or state): {String(routeOrStateInvoiceId ?? 'N/A')}
                </Typography>
            </Paper> */}

            <Paper elevation={4} sx={{ borderRadius: 3, p: 1.5 }}>
                {DebitNoteCreated && (
                    <Alert severity="warning" sx={{ mb: 1 }}>
                        Debit Note is already created. Client Details and Product Details can not be modified.
                    </Alert>
                )}
                <Stepper activeStep={activeStep} alternativeLabel sx={{ mb: 1 }}>
                    {steps.map(label => (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>

                <Divider sx={{ mb: 0.5 }} />
                {getStepComponent(activeStep)}
            </Paper>

            <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={handleCloseSnackbar} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} >
                <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} variant="filled">
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Box>
    );
};

export default PurcInvoiceMaster;